module.exports = __webpack_public_path__ + "static/media/FM_Privacy_Policy_September_2023-ASIC.2f814303.pdf";